import { Component, Input, OnInit } from '@angular/core';
import { PGUtilities } from '../../utilities/pg-utilities';

@Component({
    selector: 'app-pg-tag-image',
    templateUrl: './pg-tag-image.component.html',
    styleUrls: ['./pg-tag-image.component.scss'],
    standalone: false
})
export class PgTagImageComponent implements OnInit {
    @Input() tag: string;
    @Input() image: string;
    @Input() color: string;

    ngOnInit(): void {
        if(this.color == null) this.color = 'secondary'
    }

    getColorClass() {
        if(this.color) {
            if(PGUtilities.isValidColorClass(this.color)) return this.color
        }
    }

    getColorStyle() {
        if(this.color) {
            if(!PGUtilities.isValidColorClass(this.color)) return this.color + ' !important'
        }
    }
}
